export default __webpack_public_path__ + "static/media/mobile_confirmation.1ca100ba.svg";